import { render, staticRenderFns } from "./home-content.vue?vue&type=template&id=2a57883a&scoped=true"
import script from "./home-content.vue?vue&type=script&lang=js"
export * from "./home-content.vue?vue&type=script&lang=js"
import style0 from "./home-content.vue?vue&type=style&index=0&id=2a57883a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a57883a",
  null
  
)

export default component.exports